import { Loader2 } from 'lucide-react';

/**
 * Enquanto o código de uma página ainda baixa (primeira visita a ela). Mora
 * dentro dos layouts, em volta do conteúdo: só a área da página espera, o menu
 * e o topo continuam no lugar. Antes havia um único carregador em volta de
 * todas as rotas, e na primeira visita a tela inteira sumia junto com a
 * lateral.
 */
export function CarregandoPagina() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <Loader2 className="text-primary h-8 w-8 animate-spin" />
    </div>
  );
}
